import clsx from "clsx";
import React from "react";
import { AppContext } from "~/context/appContext";
import PageWiseBanner from "~/pages/PageWiseBanner";

// Toasts render through GlobalLayout now - InAppAnnouncementRoot was dead weight here (ENG-12178).
export default function AdminLayout({
  children,
  contextValue = {},
  wrapperClassName,
  contentWrapperClassName,
  announcementWrapperClassName,
  announcements,
  onBannerVisibleChange,
}) {
  return (
    <AppContext.Provider value={contextValue}>
      <div
        className={clsx(
          "min-h-screen pt-20 md:pt-0 transition-all duration-500",
          wrapperClassName,
        )}
        style={{ marginTop: "var(--cta-banner-offset, 0px)" }}
      >
        <div className="h-auto font-display">
          <div className={clsx("px-15 py-5", contentWrapperClassName)}>
            <div className={announcementWrapperClassName}>
              <PageWiseBanner announcements={announcements} onVisibleChange={onBannerVisibleChange} />
            </div>
            {children}
          </div>
        </div>
      </div>
    </AppContext.Provider>
  );
}
